<!-- Header -->
<div class="modal-header custom-header">
  <h2 class="modal-header-label">User Action Required</h2>
</div>

<!-- Content -->
<mat-dialog-content class="custom-dialog-content">
  <div class="form-group">
    <p>
      User is already logged in on another system. <br />
      Do you want to login here? User will be logged out from the other system.
    </p>
  </div>
</mat-dialog-content>

<!-- Actions -->
<mat-dialog-actions class="custom-dialog-actions">
  <button type="button" class="btn btn-secondary btn-cancel" mat-dialog-close (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-success" (click)="allowCurrentLogin()" [mat-dialog-close]="true"
    cdkFocusInitial>Ok</button>
</mat-dialog-actions>
